/* eslint-disable react/prop-types */
import React from 'react';
import './make-model-table.scss';

const MakeAndModelHeader = ({ title }) => {
  return (
    <div className="titleWrapper">
      <div className="titleInnerWrapper">
        <p className="titleHeader">{title}</p>
      </div>
    </div>
  );
};

export default MakeAndModelHeader;
